import { AppointmentBookingClientModel, ProviderModel } from "types/generated/models";
import { BookingType, IAvailabilityData, IGroupData, IProviderData } from "types/appointmentBooking";

export const STEP_LOCATION = "location";
export const STEP_SERVICE = "service";
export const STEP_PROVIDER = "provider";
export const STEP_AVAILABILITY = "availability";
export const STEP_REGISTER = "register";
export const STEP_CONFIRMATION = "confirmation";

export type StepId =
    | typeof STEP_LOCATION
    | typeof STEP_SERVICE
    | typeof STEP_PROVIDER
    | typeof STEP_AVAILABILITY
    | typeof STEP_REGISTER
    | typeof STEP_CONFIRMATION;

export enum BookingStatus {
    IN_PROGRESS = "inProgress",
    BOOKED = "booked",
}

export interface ILocationData {
    locationId: number;
    locationName: string;
}

export interface IServiceData {
    serviceId: number;
    serviceName: string;
    amount?: number;
    portalDeposit?: number;
    taxRate?: number;
    needsDeposit?: boolean;
}

export interface IConfirmationData {
    notes: string;
    client?: AppointmentBookingClientModel;
}

export interface IPaymentData {
    hasPaid: boolean;
    hasTotalAmount: boolean;
}

export interface ISavedBookingData {
    location: ILocationData | null;
    service: IServiceData | null;
    provider: IProviderData | null;
    group: IGroupData | null;
    availability: IAvailabilityData | null;
    confirmation: IConfirmationData | null;
    payment: IPaymentData | null;
}

export interface IStepState<TData> {
    data: TData | null;
    isCompleted: boolean;
}

export type ILocationState = IStepState<ILocationData>;
export type IProviderState = IStepState<IProviderData>;
export type IGroupState = IStepState<IGroupData>;
export type IAvailabilityState = IStepState<IAvailabilityData>;
export type IConfirmationState = IStepState<IConfirmationData>;

export interface IServiceState extends IStepState<IServiceData> {
    selectedCategory?: string;
}

export interface IRegistrationState {
    isCompleted: boolean;
}

export interface INavigationState {
    currentStep: StepId;
}

export interface ISessionState {
    cancelModalOpen: boolean;
    clientPortalGuid?: string;
    bookingStatus: BookingStatus;
    bookingType: BookingType;
    completedBookingData: ISavedBookingData | null;
}

export interface IBookingState {
    location: ILocationState;
    service: IServiceState;
    availableProviders: ProviderModel[];
    provider: IProviderState;
    group: IGroupState;
    availability: IAvailabilityState;
    registration: IRegistrationState;
    confirmation: IConfirmationState;
    navigation: INavigationState;
    session: ISessionState;
}
